import React, {useEffect, useRef, useState} from 'react'
import AttributesSelector from './AttributesSelector'
import CircleColor from '../../../../shared/CircleColor'

const VariantFilter = (props) => {
    const {attributes, onChange} = props
    const isFirst = useRef(true)

    const [variantFilter, setVariantFilter] = useState({
        ...attributes.reduce((acc, attr) => {
            acc[attr.name] = attr.values.map((v) => v.code)
            return acc
        }, {}),
    })

    useEffect(() => {
        if (isFirst.current) {
            isFirst.current = false
            return
        }
        onChange?.(variantFilter)
    }, [variantFilter])

    const handleAttributesChange = (values, attrName) => {
        setVariantFilter({
            ...variantFilter,
            [attrName]: values.map((v) => v.value),
        })
    }

    const handleGetLabelForColorAttribute = (option) => {
        const {label, color_code} = option
        return (
            <div
                className={'d-flex align-items-center justify-content-center'}
                style={{
                    gap: '8px',
                }}
            >
                <CircleColor color={color_code} />
                {label}
            </div>
        )
    }

    return (
        <tr className="ProductVariantsRow FilterRow">
            <td className={'text-center CheckboxCell'}>
                <span className="fw-500">Filter</span>
            </td>
            {attributes.map((attribute) => {
                const {name, values} = attribute
                const attributeValues = values.map((v) => ({
                    ...v,
                    id: v.code,
                    value: v.code,
                    label: v.text,
                }))

                return (
                    <td
                        style={{
                            width: `calc(100% / ${attributes.length})`,
                        }}
                    >
                        <AttributesSelector
                            attributeName={name}
                            attributes={attributeValues}
                            onChange={(values) => handleAttributesChange(values, name)}
                            getLabelOption={attribute.type === 'color' ? handleGetLabelForColorAttribute : undefined}
                        />
                    </td>
                )
            })}
            <td style={{width: 0}}></td>
        </tr>
    )
}

export default VariantFilter
